/** Basic Pitch suele equivocarse ±1 semitono u ±1 octava en material monofónico corto. */
export function heardMidiMatchesExpected(heard: number, expected: number): boolean {
  const h = Math.round(heard);
  const e = Math.round(expected);
  for (const delta of [0, -12, 12, -24, 24]) {
    if (Math.abs(h - (e + delta)) <= 1) return true;
  }
  return false;
}

export function pickEventNearestMidi<T extends { pitch: number; confidence: number }>(
  events: T[],
  targetMidi: number
): T | null {
  if (events.length === 0) return null;
  const t = Math.round(targetMidi);
  const dist = (p: number) =>
    Math.min(
      Math.abs(p - t),
      Math.abs(p - t - 12),
      Math.abs(p - t + 12),
      Math.abs(p - t - 24),
      Math.abs(p - t + 24),
    );

  return events.reduce((best, e) => {
    const d = dist(Math.round(e.pitch));
    const bd = dist(Math.round(best.pitch));
    if (d < bd) return e;
    if (d === bd && e.confidence > best.confidence) return e;
    return best;
  });
}
